import React, { createContext, useContext } from 'react';

export const CenterContext = createContext(null);

export const useCenter = () => useContext(CenterContext);

export const CenterProvider = ({ children }) => {
  const dummyCenter = { id: 101, features: ['chat', 'notes'] }; // 🔧 Simulated features

  return (
    <CenterContext.Provider value={dummyCenter}>
      {children}
    </CenterContext.Provider>
  );
};
